/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Cta_DescInputs */

const en_fw_bm_cta_desc = /** @type {(inputs: Fw_Bm_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every task in Bystep carries acceptance criteria the CLI checks before the task can close. Your numbers, on your repo.`)
};

const id_fw_bm_cta_desc = /** @type {(inputs: Fw_Bm_Cta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setiap task di Bystep membawa kriteria penerimaan yang diperiksa CLI sebelum task boleh ditutup. Angkamu, di repomu.`)
};

/**
* | output |
* | --- |
* | "Every task in Bystep carries acceptance criteria the CLI checks before the task can close. Your numbers, on your repo." |
*
* @param {Fw_Bm_Cta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_cta_desc = /** @type {((inputs?: Fw_Bm_Cta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Cta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_cta_desc(inputs)
	return en_fw_bm_cta_desc(inputs)
});